import Form from "../../../../content/pages/contact/Form.js";
import * as React from 'react';
export default {
  Form,
  React
};